import { useState, useRef, useCallback } from "react";
import "./VideoSection.css";

const VIDEO_URL = "https://wemust-nest.s3.ca-central-1.amazonaws.com/1755244090403_Banner_Video.mp4";
const THUMBNAIL_URL = "https://wemust-nest.s3.ca-central-1.amazonaws.com/1768727752543_image.jpg";

const VideoSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  }, []);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) closeModal();
  };

  return (
    <>

      <section className="video-section" aria-label="Video: We Understand Consistency, Quality, And Speed">
        <div className="video-section-backdrop">
          <div
            className="video-section-thumbnail"
            style={{ backgroundImage: `url(${THUMBNAIL_URL})` }}
            aria-hidden
          />
          <div className="video-section-overlay" aria-hidden />
        </div>

        <div className="video-section-content">
          <button
            type="button"
            className="video-section-play-button"
            onClick={openModal}
            aria-label="Play video"
          >
            <span className="video-section-play-icon" aria-hidden />
          </button>
          <h2 className="video-section-headline">
            We Understand Consistency, Quality, And Speed Matters Most
          </h2>
          <p className="video-section-description">
          Consistency is built into everything we do, ensuring reliable results every time. Quality is never compromised, from planning to final delivery. Speed means meeting deadlines without cutting corners. Together, we help your business move faster, smarter, and with confidence
          </p>
        </div>
      </section>

      {isModalOpen && (
        <div
          className="video-section-modal-backdrop"
          onClick={handleBackdropClick}
          role="dialog"
          aria-modal="true"
          aria-label="Video player"
        >
          <div className="video-section-modal">
            <button
              type="button"
              className="video-section-modal-close"
              onClick={closeModal}
              aria-label="Close video"
            >
              ×
            </button>
            <video
              ref={videoRef}
              src={VIDEO_URL}
              controls
              autoPlay
              playsInline
              className="video-section-modal-video"
              onEnded={() => {}}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VideoSection;
